import template from './templates/loading.html';
export class LoadingElement {
    constructor(container, name) {
        let mainDivId = 'cbot-loader-' + name;
        let loader = $.parseHTML(template);
        $(loader).attr('id', mainDivId);
        container.append(loader);
        this.element = $('#' + mainDivId);
    }
    addContentSpaceClass() {
        this.element.addClass('cbot-js-content-space');
    }
    show() {
        this.element.show();
    }
    hide() {
        this.element.hide();
    }
}
